import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { IssueTemplate } from 'types';

type CreateIssueTemplateData = {
  name: string;
  description?: string;
  projectId?: string;
  issueType: 'task' | 'story' | 'bug' | 'epic' | 'sub-task';
  templateData: {
    title?: string;
    description?: string;
    priority?: 'low' | 'medium' | 'high';
    status?: 'to do' | 'in progress' | 'in review' | 'blocked' | 'done';
    labels?: string[];
    components?: string[];
    fixVersions?: string[];
    affectsVersions?: string[];
    environment?: 'development' | 'staging' | 'production';
    assignee?: string;
    dueDate?: string;
    epicLink?: string;
    customFields?: Record<string, unknown>;
  };
  isDefault?: boolean;
};

const createIssueTemplate = async (
  templateData: CreateIssueTemplateData
): Promise<IssueTemplate> => {
  const { data } = await customAxios.post<IssueTemplate>(
    '/issue-templates',
    templateData
  );
  return data;
};

export const useCreateIssueTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createIssueTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['issue-templates'] }).catch(() => undefined);
    },
  });
};
